import { render, staticRenderFns } from "./TranscribeInsertYourOwnGap.vue?vue&type=template&id=4e567714&scoped=true&"
import script from "./TranscribeInsertYourOwnGap.vue?vue&type=script&lang=js&"
export * from "./TranscribeInsertYourOwnGap.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeInsertYourOwnGap.vue?vue&type=style&index=0&id=4e567714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e567714",
  null
  
)

export default component.exports